var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98 68.4",
    style: {
      enableBackground: "new 0 0 98 68.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#68767A;}\r\n\t.st2{fill:#68767A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.2,
    className: "st1",
    width: 98,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 28.2,
    className: "st1",
    width: 64,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 54.2,
    className: "st1",
    width: 24,
    height: 12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "83.1,9.1 74.1,0.1 49,25.2 23.9,0.1 14.9,9.1 39.9,34.2 14.9,59.3 23.9,68.4 49,43.3 74.1,68.4  83.1,59.3 58.1,34.2  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGray);
export default __webpack_public_path__ + "static/media/close_icon_gray.413838511b8352f420031ea91d8fea7a.svg";
export { ForwardRef as ReactComponent };